/**
 * The prefix of the {@code localStorage} key into which {@link storeConfig}
 * stores and from which {@link restoreConfig} restores.
 *
 * @protected
 * @type string
 */
export const _CONFIG_STORE_PREFIX = 'config.js';
// production pusher key:
export const PUSHER_KEY = '2de8b32e2bb763808fee';
// dev pusher key:
// export const PUSHER_KEY = 'd03ee6ab9734be03fef5';
export const PUSHER_CLUSTER = 'mt1';
// Production API:
export const _CONFIG_INN_API = 'https://welltab-api-prod.panthermediasystem.net/';
// Testing Dev API:
// export const _CONFIG_INN_API = 'https://welltab-api-dev.panthermediasystem.net/';
// eslint-disable-next-line max-len
export const _CONFIG_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI1ZWJkOTA4NmM3NzdiYjBiNjQwOThjMWQiLCJlbWFpbCI6ImFkbWluQHBhbnRoZXJtZWRpYXN5c3RlbS5jb20iLCJwZXJtaXNzaW9uTGV2ZWwiOjEsInByb3ZpZGVyIjoiZW1haWwiLCJuYW1lIjoiVGVzdGVyIE1jVGVzdGVyIiwicmVmcmVzaEtleSI6IjVuakNwRmlpcDgxUk15Ym1UT3BmeUE9PSIsImlhdCI6MTU4OTQ4MTcwMH0.GNffvZLhaLdRs8il1O1Q2FmDOnxDy0q-23sNATkuys0';
export const VOLUME_CONFIG = {
    type: 'call',
    playSound: true,
    showUI: true
};
export const VOLUME_CONFIG_NON_UI = {
    type: 'call',
    playSound: true,
    showUI: false
};
export const VOLUME_CONFIG_NON_UI_MUSIC = {
    type: 'music',
    playSound: true,
    showUI: false
};
export const LOCATION = {
    FAMILY: 'family',
    PATIENT: 'patient'
};
export const VOLUME_INIT_FAMILY = 0.50;
export const VOLUME_INIT_PATIENT = 0.2;
export const INPUT_STATE = {
    INIT: 'init',
    ERROR: 'error',
    VALID: 'valid'
};
/**
 * The list of all possible UI buttons.
 *
 * @protected
 * @type Array<string>
 */
export const TOOLBAR_BUTTONS = [
    'camera',
    'chat',
    'closedcaptions',
    'desktop',
    'download',
    'embedmeeting',
    'etherpad',
    'feedback',
    'filmstrip',
    'fullscreen',
    'hangup',
    'help',
    'highlight',
    'invite',
    'linktosalesforce',
    'livestreaming',
    'microphone',
    'mute-everyone',
    'mute-video-everyone',
    'participants-pane',
    'profile',
    'raisehand',
    'recording',
    'security',
    'select-background',
    'settings',
    'shareaudio',
    'noisesuppression',
    'sharedvideo',
    'shortcuts',
    'stats',
    'tileview',
    'toggle-camera',
    'videoquality',
    'whiteboard'
];
/**
 * The toolbar buttons to show on premeeting screens.
 */
export const PREMEETING_BUTTONS = ['microphone', 'camera', 'select-background', 'invite', 'settings'];
/**
  * The toolbar buttons to show on 3rdParty prejoin screen.
  */
export const THIRD_PARTY_PREJOIN_BUTTONS = ['microphone', 'camera', 'select-background'];
/**
 * The set of feature flags.
 *
 * @enum {string}
 */
export const FEATURE_FLAGS = {
    SSRC_REWRITING: 'ssrcRewritingEnabled'
};
